import { queryKeys } from './useQueryWorkspace'
import { useFetchWorkspace } from './useFetchWorkspace'
import { useQueryClientUtils } from '../useQueryClientUtils'

const update = () => {
  const { update: mutationFn } = useFetchWorkspace()
  const { fetchActiveWorkspaceData, workspace } = useAuth()
  const { invalidateQueries, cancelQueries } = useQueryClientUtils()

  return useMutation({
    mutationFn,
    onMutate: () => {
      cancelQueries([
        queryKeys.all._def,
      ])
    },
    onSuccess: (_, { meta }) => {
      // workaround for not having proper cache invalidation in place. The employee_amount should be updated immediately to have the right value in the UI
      if (!workspace.value?.relationships?.businessProfile // should be there as this is a required relationship
        || !meta?.businessProfile
      ) {
        return
      }

      if ('employee_amount' in meta.businessProfile)
        workspace.value.relationships.businessProfile.data.attributes.employee_amount = meta?.businessProfile?.employee_amount
    },
    onSettled: (_, _1) => {
      fetchActiveWorkspaceData({ refresh: true })

      invalidateQueries([
        queryKeys.all._def,
      ])
    },
  })
}

const activatePartnership = () => {
  const { activatePartnership: mutationFn } = useFetchWorkspace()
  const { invalidateQueries, cancelQueries } = useQueryClientUtils()

  return useMutation({
    mutationFn,
    onMutate: () => {
      cancelQueries([queryKeys.all._def])
    },
    onSuccess: () => {
      invalidateQueries([queryKeys.all._def])
    },
  })
}

const create = () => {
  const { create: mutationFn } = useFetchWorkspace()
  const { fetchActiveWorkspaceData } = useAuth()
  const { invalidateQueries, cancelQueries } = useQueryClientUtils()

  return useMutation({
    mutationFn,
    onMutate: () => {
      cancelQueries([queryKeys.all._def])
    },
    onSettled: () => {
      fetchActiveWorkspaceData({ refresh: true })

      invalidateQueries([queryKeys.all._def])
    },
  })
}

const updateBillingVatNumber = () => {
  const { updateBillingVatNumber: mutationFn } = useFetchWorkspace()
  const { fetchActiveWorkspaceData } = useAuth()

  return useMutation({
    mutationFn,
    onSettled: () => {
      fetchActiveWorkspaceData({ refresh: true })
    },
  })
}

export const useMutationWorkspace = {
  update,
  activatePartnership,
  create,
  updateBillingVatNumber,
}
